export default __webpack_public_path__ + "static/media/class_info.11658ccd.svg";